import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './EmployeePayslip.css';
import { useNavigate } from 'react-router-dom';
import ExcelJS from "exceljs";
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { toWords } from 'number-to-words';
import jsPDF from "jspdf";
import fgIdentitySolutions from '../../../assets/Images/fgIdentitySolutions.jpg';
import { fetchMonths, getDistrict, getProjects, getStates } from '../../../services/monthlyAttendanceService';
import { fetchPayslipData } from '../../../services/payrollService';
import { capitalizeFirstLetter, formatNumber } from '../../../utils/validations';

const EmployeePayslip = () => {
    const navigate = useNavigate();
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        month: false,
        year: false,
        project: false,
    });
    const [errors, setErrors] = useState({});
    const [hasFetched, setHasFetched] = useState(false);
    const yearInputRef = useRef(null);
    const isFetchDataEnabled = month && year;
    // const selectStyles = {
    //     menuPortal: base => ({ ...base, zIndex: 9999 }),
    //     menu: base => ({ ...base, marginTop: '5px', zIndex: 9999 }),
    //     control: provided => ({ ...provided, padding: '1px' }),
    //     valueContainer: provided => ({ ...provided, padding: '3px 6px' }),
    // };
    const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);
    const employeeId = localStorage.getItem("employeeId");
    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
              //  const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
              const data= await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                        name: capitalizeFirstLetter(item.stateName)
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        fetchStates();
    }, []);

    // Fetch months
        useEffect(() => {
            const loadMonths = async () => {
                try {
                    const months = await fetchMonths(year);
                    setMonthOptions(months);
                } catch (error) {
                    console.error("Error fetching months:", error);
                    setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
                }
            };
            loadMonths();
        }, [year]);
//     useEffect(() => {
//         const fetchMonths = async () => {
//             try {
//                 const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/months`);
//                 const now = new Date();
//                 const currentYear = now.getFullYear();
//                 const currentMonth = now.getMonth() + 1;
//                 const currentDate = now.getDate();
//                 const lastDayOfCurrentMonth = new Date(currentYear, currentMonth, 0).getDate();

//                 const months = response.data
//                     .map(item => {
//                         let daysInMonth;
//                         if (year === currentYear && item.monthId === currentMonth) {
//                             daysInMonth = currentDate;
//                         } else {
//                             daysInMonth = new Date(year, item.monthId, 0).getDate();
//                         }
//                         return {
//                             value: item.monthId,
//                             label: item.monthName,
//                             days: daysInMonth,
//                         };
//                     })
//                     .sort((a, b) => a.value - b.value);

//                 let filteredMonths = months;
//                 // if (year) {
//                 //     if (year === currentYear) {
//                 //         filteredMonths = months.filter(m => {
//                 //             if (m.value < currentMonth) return true;
//                 //             if (m.value === currentMonth) {
//                 //                 return currentDate === lastDayOfCurrentMonth;
//                 //             }
//                 //             return false;
//                 //         });
//                 //     } else if (year > currentYear) {
//                 //         filteredMonths = [];
//                 //     } else {
//                 //         filteredMonths = months;
//                 //     }
//                 // }
//                 if (year) {
//     if (year === currentYear) {
//         // Include current month only if date >= 10
//         const cutoff = currentDate >= 10 ? currentMonth : currentMonth - 1;
//         filteredMonths = months.filter(m => m.value <= cutoff);
//     } 
//     else if (year < currentYear) {
//         // Past years → show all months
//         filteredMonths = months;
//     } 
//     else {
//         // Future years → show none
//         filteredMonths = [];
//     }
// }


//                 setMonthOptions(filteredMonths);
//             } catch (error) {
//                 console.error('Error fetching months:', error);
//                 setErrors(prev => ({ ...prev, general: 'Failed to load months' }));
//             }
//         };
//         fetchMonths();
//     }, [year]);

    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                   // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${state}`);
                   const data= await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null);
            setMonth(null);
            setAttendanceData([]);
            setHasFetched(false);
        }
    }, [state]);
    useEffect(() => {
        const fetchProjects = async () => {
            try {
               // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects`);
                const data= await getProjects();
                setProjectResponse(data.map(pro => ({
                    value: pro.id,
                    label: pro.projectCode,
                }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        fetchProjects();
    }, []);
    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setAttendanceData([]);
                setHasFetched(false);
                setProject(null);
                break;
            case 'district':
                setDistrict(value);
                setMonth(null);
                setAttendanceData([]);
                setHasFetched(false);
                setProject(null);
                break;
            case 'month':
                setMonth(value);
                setAttendanceData([]);
                setHasFetched(false);
                setProject(null);
                break;
            case 'project':
                setProject(value); // ✅ Handle project selection
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const handleYearChange = (date) => {
        const newYear = date ? date.getFullYear() : null;
        setYear(newYear);
        setMonth(null);
        setAttendanceData([]);
        setHasFetched(false);
        setErrors(prev => ({ ...prev, year: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        //  if (!state) newErrors.state = 'State is required';
        // if (!district) newErrors.district = 'District is required';
        if (!month) newErrors.month = 'Month is required';
        if (!year) newErrors.year = 'Year is required';
        setErrors(prev => ({ ...prev, ...newErrors }));
        return Object.keys(newErrors).length === 0;
    };

const handleFetch = async (e) => {
  e.preventDefault();
  if (!validateForm()) return;

  try {
    const params = {
      month,
      year,
    };

    if (employeeId) {
      params.employeeId = employeeId;
    }

    console.log("📦 Request params:", params);

    const data = await fetchPayslipData(params);

    console.log("✅ API response:", data);
    setAttendanceData(data);
    setOriginalData(data);
    setHasFetched(true);
    setErrors((prev) => ({ ...prev, general: null }));
  } catch (error) {
    console.error("Error fetching payslip data:", error);
    setErrors((prev) => ({
      ...prev,
      general: error.response?.data?.message || "Failed to fetch payslip data",
    }));
    setAttendanceData([]);
    setHasFetched(false);
  }
};
    // Download Excel Function
    const downloadExcel = () => {
        // Create a new workbook
        const wb = new ExcelJS.Workbook();

        // Iterate over each employee to create a new worksheet
        attendanceData.forEach((emp, index) => {
            const ws = wb.addWorksheet(`Payslip-${emp.employeeId}`);

            // Adding headers
            ws.addRow([`Employee Payslip - ${emp.fullName || "Employee"}`]);
            ws.addRow([]);
            ws.addRow(["Employee Number", "Date Joined", "Department", "Designation"]);
            ws.addRow([emp.employeeId, emp.joiningDate, emp.department, emp.designation]);
            ws.addRow(["Bank", "IFSC Code", "Account Number", "Payment Mode"]);
            ws.addRow([emp.bankName, emp.ifscCode, emp.accountNumber, emp.paymentMode]);
            ws.addRow(["PAN", "UAN", "Member ID", "ESIC No"]);
            ws.addRow([emp.panNumber, emp.uanNumber, emp.memberId, emp.esiNumber]);
            ws.addRow(["Payable Days", "Total Working Days", "Loss of Pay Days", "Days Payable"]);
            ws.addRow([emp.payableDays, emp.totalDaysInMonth, emp.absentDays, emp.payableDays]);
            ws.addRow(["Basic", "Conveyance Allowance", "HRA", "Medical Allowance"]);
            ws.addRow([emp.defaultBasicSalary, emp.defaultConveyance, emp.defaultHra, emp.defaultMedicalAllowance]);
            ws.addRow(["Special Allowance", "Total Earnings", "Professional Tax", "TDS"]);
            ws.addRow([emp.defaultSpecialAllowance, emp.totalEarnings, emp.defaultPt, emp.tds]);
            ws.addRow(["Net Salary Payable", emp.calculatedNetSalary]);
            ws.addRow(["Net Salary in words", toWords(emp.calculatedNetSalary)]);

            // Optional: Adjust column widths
            ws.getColumn(1).width = 30;
            ws.getColumn(2).width = 20;
            ws.getColumn(3).width = 30;
            ws.getColumn(4).width = 20;
        });

        // Write to file
        wb.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = "Employee_Payslips.xlsx";
            link.click();
        });
    };
    // const formatNumber = (value) => {
    //     if (typeof value === "number" && value >= 1000) {
    //         return value.toLocaleString("en-IN"); // en-US or en-IN depending on your format
    //     }
    //     return value;
    // }
    
    // Download PDF Function
    //    const downloadPDF = () => {
    //     const doc = new jsPDF("p", "pt", "a4");

    //     attendanceData.forEach((emp, index) => {
    //       if (index !== 0) doc.addPage();

    //       // Employee Name
    //       doc.setFontSize(16);
    //       doc.text(emp.fullName || "Employee", 40, 40);

    //       // First Table: Employee Info
    //       doc.autoTable({
    //         startY: 60,
    //         head: [["Employee Number", "Date Joined", "Department", "Designation"]],
    //         body: [[emp.employeeId, emp.joiningDate, emp.department, emp.designation]],
    //       });

    //       // Second Table: Bank Info
    //       doc.autoTable({
    //         startY: doc.lastAutoTable.finalY + 20,
    //         head: [["Bank", "IFSC Code", "Account Number", "Payment Mode"]],
    //         body: [[emp.bankName, emp.ifscCode, emp.accountNumber, emp.paymentMode]],
    //       });

    //       // Third Table: IDs
    //       doc.autoTable({
    //         startY: doc.lastAutoTable.finalY + 20,
    //         head: [["PAN", "UAN", "Member ID", "ESIC No"]],
    //         body: [[emp.panNumber, emp.uanNumber, emp.memberId, emp.esiNumber]],
    //       });

    //       // Details Table
    //       doc.setFontSize(14);
    //       doc.text("Details", 40, doc.lastAutoTable.finalY + 40);
    //       doc.autoTable({
    //         startY: doc.lastAutoTable.finalY + 50,
    //         head: [["Payable Days", "Total Working Days", "Loss of Pay Days", "Days Payable"]],
    //         body: [[emp.payableDays, emp.totalDaysInMonth, emp.absentDays, emp.payableDays]],
    //       });

    //       // Earnings & Contributions
    //       doc.autoTable({
    //         startY: doc.lastAutoTable.finalY + 20,
    //         head: [["EARNINGS", "", "CONTRIBUTIONS", ""]],
    //         body: [
    //           ["Basic", emp.defaultBasicSalary, "PF Employee", emp.calculatedPt],
    //           ["Conveyance Allowance", emp.defaultConveyance, "Total Contributions (B)", emp.totalContributions],
    //           ["HRA", emp.defaultHra, "TAXES & DEDUCTIONS", ""],
    //           ["Medical Allowance", emp.defaultMedicalAllowance, "Professional Tax", emp.defaultPt],
    //           ["Special Allowance", emp.defaultSpecialAllowance, "TDS", emp.tds],
    //           ["Total Earnings (A)", emp.totalEarnings, "Total Deductions (C)", emp.calculatedTotalDeductions],
    //         ],
    //       });

    //       // Net Salary
    //       doc.autoTable({
    //         startY: doc.lastAutoTable.finalY + 20,
    //         body: [
    //           ["Net Salary Payable (A-B-C)", emp.calculatedNetSalary],
    //           [
    //             "Net Salary in words",
    //             emp.calculatedNetSalary
    //               ? toWords(emp.calculatedNetSalary).replace(/\b\w/g, (c) => c.toUpperCase())
    //               : "Invalid Salary",
    //           ],
    //         ],
    //       });
    //     });

    //     doc.save("payslip.pdf");
    //   };
    // Download PDF Function
    // const downloadPDF = () => {
    //   const doc = new jsPDF("p", "pt", "a4");

    //   attendanceData.forEach((emp, index) => {
    //     if (index !== 0) doc.addPage();

    //     // ============================
    //     // HEADER SECTION
    //     // ============================
    //     doc.setFontSize(20);
    //     doc.setFont("helvetica", "bold");
    //     doc.text("PAYSLIP", 40, 40); // Left side Title

    //     // Add Company Logo (Right side)
    //     // Replace with your image base64 OR public/logo.png
    //     const logoUrl = "/logo.png"; // path inside public folder
    //     const img = new Image();
    //     img.src = logoUrl;

    //     // since addImage needs loaded image, wrap in onload
    //     img.onload = () => {
    //       doc.addImage(img, "PNG", 450, 20, 100, 50); // X, Y, Width, Height
    //     };

    //     // ============================
    //     // MONTH & YEAR SECTION
    //     // ============================
    //     doc.setFontSize(14);
    //     doc.setFont("helvetica", "normal");
    //     const monthName = monthOptions.find(opt => opt.value === month)?.label || "";
    //     doc.text(`${monthName} ${year}`, 40, 70);

    //     // ============================
    //     // Employee Name
    //     // ============================
    //     doc.setFontSize(16);
    //     doc.text(emp.fullName || "Employee", 40, 100);

    //     // First Table: Employee Info
    //     doc.autoTable({
    //       startY: 120,
    //       head: [["Employee Number", "Date Joined", "Department", "Designation"]],
    //       body: [[emp.employeeId, emp.joiningDate, emp.department, emp.designation]],
    //     });

    //     // Second Table: Bank Info
    //     doc.autoTable({
    //       startY: doc.lastAutoTable.finalY + 20,
    //       head: [["Bank", "IFSC Code", "Account Number", "Payment Mode"]],
    //       body: [[emp.bankName, emp.ifscCode, emp.accountNumber, emp.paymentMode]],
    //     });

    //     // Third Table: IDs
    //     doc.autoTable({
    //       startY: doc.lastAutoTable.finalY + 20,
    //       head: [["PAN", "UAN", "Member ID", "ESIC No"]],
    //       body: [[emp.panNumber, emp.uanNumber, emp.memberId, emp.esiNumber]],
    //     });

    //     // Details Table
    //     doc.setFontSize(14);
    //     doc.text("Details", 40, doc.lastAutoTable.finalY + 40);
    //     doc.autoTable({
    //       startY: doc.lastAutoTable.finalY + 50,
    //       head: [["Payable Days", "Total Working Days", "Loss of Pay Days", "Days Payable"]],
    //       body: [[emp.payableDays, emp.totalDaysInMonth, emp.absentDays, emp.payableDays]],
    //     });

    //     // Earnings & Contributions
    //     doc.autoTable({
    //       startY: doc.lastAutoTable.finalY + 20,
    //       head: [["EARNINGS", "", "CONTRIBUTIONS", ""]],
    //       body: [
    //         ["Basic", emp.defaultBasicSalary, "PF Employee", emp.calculatedPt],
    //         ["Conveyance Allowance", emp.defaultConveyance, "Total Contributions (B)", emp.totalContributions],
    //         ["HRA", emp.defaultHra, "TAXES & DEDUCTIONS", ""],
    //         ["Medical Allowance", emp.defaultMedicalAllowance, "Professional Tax", emp.defaultPt],
    //         ["Special Allowance", emp.defaultSpecialAllowance, "TDS", emp.tds],
    //         ["Total Earnings (A)", emp.totalEarnings, "Total Deductions (C)", emp.calculatedTotalDeductions],
    //       ],
    //     });

    //     // Net Salary
    //     doc.autoTable({
    //       startY: doc.lastAutoTable.finalY + 20,
    //       body: [
    //         ["Net Salary Payable (A-B-C)", emp.calculatedNetSalary],
    //         [
    //           "Net Salary in words",
    //           emp.calculatedNetSalary
    //             ? toWords(emp.calculatedNetSalary).replace(/\b\w/g, (c) => c.toUpperCase())
    //             : "Invalid Salary",
    //         ],
    //       ],
    //     });
    //   });

    //   doc.save("payslip.pdf");
    // };
    // const downloadPDF = () => {
    //   const doc = new jsPDF("p", "pt", "a4");

    //   attendanceData.forEach((emp, index) => {
    //     if (index !== 0) doc.addPage();

    //     // ============================
    //     // HEADER ROW
    //     // ============================

    //     const monthName = monthOptions.find(opt => opt.value === month)?.label || "";
    //     const headerText = `PAYSLIP  ${monthName} ${year}`;

    //     doc.setFontSize(18);
    //     doc.setFont("helvetica", "bold");

    //     // Left side text
    //     doc.text(headerText, 40, 50);

    //    doc.addImage(fgIdentitySolutions, "JPEG", 450, 20, 100, 80);


    //     // ============================
    //     // Employee Name
    //     // ============================
    //     doc.setFontSize(14);
    //     doc.text(emp.fullName || "Employee", 40, 105);

    //     // Employee Info
    //     doc.autoTable({
    //       startY: 110,
    //       head: [["Employee Number", "Date Joined", "Department", "Designation"]],
    //       body: [[emp.employeeId, emp.joiningDate, emp.department, emp.designation]],
    //     });

    //     // Bank Info
    //     doc.autoTable({
    //       startY: doc.lastAutoTable.finalY + 20,
    //       head: [["Bank", "IFSC Code", "Account Number", "Payment Mode"]],
    //       body: [[emp.bankName, emp.ifscCode, emp.accountNumber, emp.paymentMode]],
    //     });

    //     // IDs
    //     doc.autoTable({
    //       startY: doc.lastAutoTable.finalY + 20,
    //       head: [["PAN", "UAN", "Member ID", "ESIC No"]],
    //       body: [[emp.panNumber, emp.uanNumber, emp.memberId, emp.esiNumber]],
    //     });

    //     // Details Table
    //     doc.setFontSize(14);
    //     doc.text("Details", 40, doc.lastAutoTable.finalY + 40);
    //     doc.autoTable({
    //       startY: doc.lastAutoTable.finalY + 50,
    //       head: [["Payable Days", "Total Working Days", "Loss of Pay Days", "Days Payable"]],
    //       body: [[emp.payableDays, emp.totalDaysInMonth, emp.absentDays, emp.payableDays]],
    //     });

    //     // Earnings & Contributions
    //     doc.autoTable({
    //       startY: doc.lastAutoTable.finalY + 20,
    //       head: [["EARNINGS", "", "CONTRIBUTIONS", ""]],
    //       body: [
    //         ["Basic", emp.defaultBasicSalary, "PF Employee", emp.calculatedPt],
    //         ["Conveyance Allowance", emp.defaultConveyance, "Total Contributions (B)", emp.totalContributions],
    //         ["HRA", emp.defaultHra, "TAXES & DEDUCTIONS", ""],
    //         ["Medical Allowance", emp.defaultMedicalAllowance, "Professional Tax", emp.defaultPt],
    //         ["Special Allowance", emp.defaultSpecialAllowance, "TDS", emp.tds],
    //         ["Total Earnings (A)", emp.totalEarnings, "Total Deductions (C)", emp.calculatedTotalDeductions],
    //       ],
    //     });

    //     // Net Salary
    //     doc.autoTable({
    //       startY: doc.lastAutoTable.finalY + 20,
    //       body: [
    //         ["Net Salary Payable (A-B-C)", emp.calculatedNetSalary],
    //         [
    //           "Net Salary in words",
    //           emp.calculatedNetSalary
    //             ? toWords(emp.calculatedNetSalary).replace(/\b\w/g, (c) => c.toUpperCase())
    //             : "Invalid Salary",
    //         ],
    //       ],
    //     });
    //   });

    //   doc.save("payslip.pdf");
    // };
    const downloadPDF = () => {
        const doc = new jsPDF("p", "pt", "a4");

        attendanceData.forEach((emp, index) => {
            if (index !== 0) doc.addPage();
            const monthName = monthOptions.find(opt => opt.value === month)?.label || "";
            const headerText = `PAYSLIP  ${monthName} ${year}`;

            doc.setFontSize(18);
            doc.setFont("helvetica", "bold");

            // Left side text
            doc.text(headerText, 40, 50);
            // Left side: Header + Company Info
            // doc.text(headerText, 40, 40);
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.text("4G Identity Solutions Pvt Ltd.", 40, 70);
            doc.text("Flot No.280, Road No.78, Jubilee Hills,", 40, 82);
            doc.text("Hyderabad, Telangana - 500033", 40, 94);
            // Right side logo
            doc.addImage(fgIdentitySolutions, "JPEG", 430, 20, 100, 80);

            // ============================
            // Employee Name
            // ============================
            doc.setFontSize(14);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);
            doc.text(emp.fullName || "Employee", 40, 140);
            doc.setLineWidth(0.5); // thickness of the line
            doc.line(40, 145, 550, 145); // from left (40) to right (550) at y=145
            // Define common column widths
            const columnStyles = {
                0: { cellWidth: 120 }, // First column
                1: { cellWidth: 120 }, // Second column
                2: { cellWidth: 140 }, // Third column
                3: { cellWidth: 130 }, // Fourth column
            };

            // Employee Info Table
            doc.autoTable({
                startY: 145,
                head: [["Employee Number", "Date Joined", "Location", "Designation"]],
                body: [[emp.employeeId, emp.joiningDate, emp.districtName || '-', emp.designation]],
                headStyles: {
                    fillColor: false,
                    textColor: [128, 128, 128],
                    fontStyle: "bold",
                },
                bodyStyles: {
                    fillColor: false,
                    textColor: [0, 0, 0],
                },
                columnStyles: columnStyles,
                tableWidth: "auto",
            });

            // Bank Info Table
            doc.autoTable({
                startY: doc.lastAutoTable.finalY,
                head: [["Bank", "IFSC Code", "Account Number", "Payment Mode"]],
                body: [[emp.bankName, emp.ifscCode, emp.accountNumber, "Bank Transfer"]],
                headStyles: {
                    fillColor: false,
                    textColor: [128, 128, 128],
                    fontStyle: "bold",
                },
                bodyStyles: {
                    fillColor: false,
                    textColor: [0, 0, 0],
                },
                columnStyles: columnStyles,
                tableWidth: "auto",
            });

            // IDs Table
            doc.autoTable({
                startY: doc.lastAutoTable.finalY,
                head: [["PAN", "UAN", "Member ID", "ESIC No"]],
                body: [[emp.panNumber, emp.uanNumber, emp.memberId, emp.esiNumber]],
                headStyles: {
                    fillColor: false,
                    textColor: [128, 128, 128],
                    fontStyle: "bold",
                },
                bodyStyles: {
                    fillColor: false,
                    textColor: [0, 0, 0],
                },
                columnStyles: columnStyles,
                tableWidth: "auto",
            });

            // Details Table
            doc.setFontSize(14);
            doc.text("Salary Details", 40, doc.lastAutoTable.finalY + 40);
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 50,
                head: [["No.of Days In Month", "Loss of Pay Days", "Days Payable", ""]],
                body: [[emp.totalDaysInMonth, emp.absentDays, emp.payableDays, " "]],
                headStyles: {
                    fillColor: false,
                    textColor: [128, 128, 128],
                    fontStyle: "bold"
                },
                bodyStyles: {
                    fillColor: false,
                    textColor: [0, 0, 0],
                },
                tableWidth: "auto",
            });

            // Earnings & Contributions Table
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 20,
                head: [["EARNINGS", "", "EMPLOYER CONTRIBUTION", ""]],
                body: [
                    ["Basic", formatNumber(emp.calculatedBasicSalary), "EPF", emp.calculatedEmployerEpf],
                    ["Conveyance Allowance", formatNumber(emp.calculatedConveyance), "ESI", emp.calculatedEmployerEsi || '-'],
                    ["HRA", formatNumber(emp.calculatedHra), "Total Contributions (B)", formatNumber(((emp.calculatedEmployerEpf || 0) + (emp.calculatedEmployerEsi || 0)))],
                    ["Medical Allowance", emp.calculatedMedicalAllowance, "EMPLOYEE DEDUCTIONS", ""],
                    ["Special Allowance", formatNumber(emp.calculatedOtherAllowance), "EPF", formatNumber(emp.calculatedEpf) || '-'],
                    ["Total Earnings (A)", formatNumber(emp.calculatedGrossSalary) || '-', "ESI", emp.calculatedEsi || '-'],
                    [" ", " ", "Professional Tax", emp.calculatedPt],
                    [" ", " ", "TPDS", formatNumber(emp.tpds)],
                    [" ", " ", "Total Deductions (C)", formatNumber(emp.calculatedTotalDeductions)],
                    // ✅ Net Salary Payable in same alignment
                    ["Net Salary Payable", formatNumber(emp.calculatedNetSalary), " ", " "],
                ],
                headStyles: {
                    fillColor: false,
                    textColor: [128, 128, 128], // light grey
                    fontStyle: "bold",
                },
                bodyStyles: {
                    fillColor: false,
                    textColor: [0, 0, 0],
                },

                columnStyles: {
                    0: { halign: "left" },    // Earning labels
                    1: { halign: "right" },  // Earning values
                    2: { halign: "left" },    // Contribution/Deduction labels
                    3: { halign: "right" },  // Contribution/Deduction values
                },

                didParseCell: (data) => {
                    // Bold totals
                    const boldBlack = ["Total Earnings (A)", "Total Contributions (B)", "Total Deductions (C)"];
                    if (boldBlack.includes(data.cell.raw)) {
                        data.cell.styles.fontStyle = "bold";
                        data.cell.styles.textColor = [0, 0, 0];
                    }
                    // Section headers in grey bold
                    const sectionHeaders = ["EMPLOYEE DEDUCTIONS"];
                    if (sectionHeaders.includes(data.cell.raw)) {
                        data.cell.styles.fontStyle = "bold";
                        data.cell.styles.textColor = [128, 128, 128];
                    }
                },
            });

            // Net Salary In Words Table
            doc.autoTable({
                startY: doc.lastAutoTable.finalY,
                body: [
                    [
                        "Net Salary in words",
                        emp.calculatedNetSalary
                            ? toWords(emp.calculatedNetSalary)
                                .replace(/,/g, "")            // remove commas
                                .replace(/-/g, " ")          // replace hyphens with space
                                .replace(/\b\w/g, (c) => c.toUpperCase()) // capitalize
                                .replace(/\s*Only$/i, "")
                            : "Invalid Salary",
                    ],
                ],
                headStyles: {
                    fillColor: false,
                    textColor: [128, 128, 128],
                    fontStyle: "bold",
                },
                bodyStyles: {
                    fillColor: false,
                    textColor: [0, 0, 0],
                },
                columnStyles: {
                    0: { halign: "left" }, // static label stays normal
                    1: { halign: "left", cellPadding: { left: 50 } }, // 🔹 shift only dynamic value a bit
                },
                didParseCell: (data) => {
                    if (data.column.index === 1) { // 🔹 only affect dynamic value column
                        data.cell.styles.fontStyle = "bold";
                        data.cell.styles.textColor = [0, 0, 0];
                    }
                },
            });

            // ============================
            // Footer Note
            // ============================
            const pageHeight = doc.internal.pageSize.height;
            const footerY = doc.lastAutoTable.finalY + 40;

            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);
            doc.text("**Note : All amounts displayed in this payslip are in INR", 40, footerY);
            doc.text("*This is computer generated statement, does not require signature.", 40, footerY + 15);
        });

        doc.save("payslip.pdf");
    };

    return (
        <>
            <div className="payslip-container">
                <div className="payslip-box">
                    <h2 className="payslip-heading">Employee Payslip Generation</h2>
                    {errors.general && <div className="error-message">{errors.general}</div>}
                    <form onSubmit={handleFetch}>
                        {/* <div className="payslip-maincontainer">
                            <div className="payslip-container-part">
                                <div className={`payslip-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                    <Select
                                        name="state"
                                        options={stateOptions}
                                        value={stateOptions.find(opt => opt.value === state) || null}
                                        onChange={option => handleInputChange(option, 'state')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>
                                        <span className="required">*</span>State
                                    </label>
                                    {errors.state && <div className="error-message">{errors.state}</div>}
                                </div>
                            </div>
                            <div className="payslip-container-part">
                                <div className={`payslip-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                    <Select
                                        name="district"
                                        options={districtOptions}
                                        value={districtOptions.find(opt => opt.value === district) || null}
                                        onChange={option => handleInputChange(option, 'district')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>
                                        District
                                    </label>
                                    {errors.district && <div className="error-message">{errors.district}</div>}
                                </div>
                            </div>
                        </div> */}
                        <div className="payslip-maincontainer">
                            <div className="payslip-container-part">
                                <div className={`payslip-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                    <DatePicker
                                        selected={year ? new Date(year, 0, 1) : null}
                                        onChange={handleYearChange}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                        dateFormat="yyyy"
                                        showYearPicker
                                        placeholderText=""
                                        className="payslip-date-picker"
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        ref={yearInputRef}
                                    />
                                    <label>
                                        <span className="required">*</span>Year
                                    </label>
                                    {errors.year && <div className="error-message">{errors.year}</div>}
                                </div>
                            </div>
                            <div className="payslip-container-part">
                                <div className={`payslip-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                    <Select
                                        name="month"
                                        options={monthOptions}
                                        value={monthOptions.find(opt => opt.value === month) || null}
                                        onChange={option => handleInputChange(option, 'month')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>
                                        <span className="required">*</span>Month
                                    </label>
                                    {errors.month && <div className="error-message">{errors.month}</div>}
                                </div>
                            </div>
                        </div>
                        {/* <div className="payslip-maincontainer">

                            <div className="payslip-container-part">
                                <div className={`payslip-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                                    <Select
                                        name="project"
                                        options={projectResponse}
                                        value={projectResponse.find(opt => opt.value === project) || null}
                                        onChange={option => handleInputChange(option, 'project')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>
                                        Project
                                    </label>
                                    {errors.project && <div className="error-message">{errors.project}</div>}
                                </div>
                            </div>
                            <div className="payslip-container-part">

                            </div>
                        </div> */}
                        <div className="payslip-btn-div">
                            <button
                                type="submit"
                                className="payslip-btn"
                                disabled={!isFetchDataEnabled}
                            >
                                Fetch Data
                            </button>
                        </div>
                    </form>


                </div>

            </div>
            <div className="payslip-table-container">
                {/* <button
                    className="download-excel-btn"
                    onClick={downloadExcel}
                >
                    Download Excel
                </button> */}

                {attendanceData && attendanceData.length > 0 ? (

                    attendanceData.map((emp, index) => (

                        <React.Fragment key={index}> {/* Use a unique key */}
                            <button
                                className="download-pdf"
                                onClick={downloadPDF}
                            >
                                Download PDF
                            </button>
                            <h3 className='payslip-title'>{emp.fullName || "Employee"}</h3>

                            <table className="payslip-table">
                                <thead>
                                    <tr>
                                        <th>Employee Number</th>
                                        <th>Date Joined</th>
                                        <th>Location</th>
                                        <th>Designation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{emp.employeeId}</td>
                                        <td>{emp.joiningDate}</td>
                                        <td>{emp.districtName || '-'}</td>
                                        <td>{emp.designation}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className="payslip-table">
                                <thead>
                                    <tr>
                                        <th>Bank</th>
                                        <th>IFSC Code</th>
                                        <th>Account Number</th>
                                        <th>Payment Mode</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{emp.bankName}</td>
                                        <td>{emp.ifscCode}</td>
                                        <td>{emp.accountNumber}</td>
                                        <td>Bank Transfer</td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className="payslip-table">
                                <thead>
                                    <tr>
                                        <th>PAN</th>
                                        <th>UAN</th>
                                        <th>Member ID</th>
                                        <th>ESIC No</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{emp.panNumber}</td>
                                        <td>{emp.uanNumber}</td>
                                        <td>{emp.memberId}</td>
                                        <td>{emp.esiNumber}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <h3 className='payslip-title'>Salary Details</h3>
                            <table className="payslip-table">
                                <thead>
                                    <tr>
                                        {/* <th>Payable Days</th> */}
                                        <th>No.of Days In Month</th>
                                        <th>Loss of Pay Days</th>
                                        <th colSpan={2}>Days Payable</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        {/* <td>{emp.payableDays}</td> */}
                                        <td>{emp.totalDaysInMonth}</td>
                                        <td>{emp.absentDays}</td>
                                        <td colSpan={2}>{emp.payableDays}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <br />

                            <table className="payslip-table">
                                <thead className="payslip-main-header">
                                    <tr>
                                        <th colSpan="2">EARNINGS</th>
                                        <th colSpan="2">EMPLOYER CONTRIBUTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Basic</td>
                                        <td className="payslip-value">{formatNumber(emp.calculatedBasicSalary)}</td>
                                        <td>EPF</td>
                                        <td className="payslip-value">{formatNumber(emp.calculatedEmployerEpf)}</td>
                                    </tr>
                                    <tr>
                                        <td>Conveyance Allowance</td>
                                        <td className="payslip-value">{formatNumber(emp.calculatedConveyance)}</td>
                                        <td>ESI</td>
                                        <td className="payslip-value">{emp.calculatedEmployerEsi || '-'}</td>
                                        {/* <td className="payslip-cell">Total Contributions (B)</td>
                                        <td>{emp.totalContributions||'-'}</td> */}
                                    </tr>
                                    <tr>
                                        <td>HRA</td>
                                        <td className="payslip-value">{formatNumber(emp.calculatedHra)}</td>
                                        <td className="payslip-cell">Total Contributions (B)</td>
                                        <td className="payslip-value">
                                            {formatNumber(((emp.calculatedEmployerEpf || 0) + (emp.calculatedEmployerEsi || 0)))}
                                        </td>
                                        {/* <td className="payslip-cell" colSpan="2">TAXES & DEDUCTIONS</td> */}
                                    </tr>
                                    <tr>
                                        <td>Medical Allowance</td>
                                        <td className="payslip-value">{emp.calculatedMedicalAllowance}</td>
                                        <th className="payslip-cell" colSpan="2">EMPLOYEE DEDUCTIONS</th>

                                    </tr>
                                    <tr>
                                        <td>Special Allowance</td>
                                        <td className="payslip-value">{formatNumber(emp.calculatedOtherAllowance)}</td>
                                        <td>EPF</td>
                                        <td className="payslip-value">{formatNumber(emp.calculatedEpf)}</td>


                                    </tr>
                                    <tr>
                                        <td className="payslip-cell">Total Earnings (A)</td>
                                        <td className="payslip-value">{formatNumber(emp.calculatedGrossSalary) || '-'}</td>
                                        <td>ESI</td>
                                        <td className="payslip-value">{emp.calculatedEsi || '-'}</td>


                                    </tr>

                                    <tr>
                                        <td colSpan="2"></td>
                                        <td>Professional Tax</td>
                                        <td className="payslip-value">{emp.calculatedPt}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2"></td>
                                        <td>TDS</td>
                                        <td className="payslip-value">{emp.tds || '-'}</td>

                                    </tr>
                                    <tr>
                                        <td colSpan="2"></td>

                                        <td className="payslip-cell">Total Deductions (C)</td>
                                        <td className="payslip-value">{formatNumber(emp.calculatedTotalDeductions)}</td>

                                    </tr>
                                </tbody>
                            </table>

                            <table className="payslip-table">
                                <tbody>
                                    <tr>
                                        <td>Net Salary Payable</td>
                                        <td className="payslip-value">{formatNumber(emp.calculatedNetSalary)}</td>
                                        <td colSpan="2"></td>
                                    </tr>
                                    <tr>
                                        <td>Net Salary in words</td>
                                        <td className="payslip-cell" colSpan="3">
                                            {emp.calculatedNetSalary
                                                ? toWords(emp.calculatedNetSalary).replace(/\b\w/g, char => char.toUpperCase())
                                                : 'Invalid Salary'}
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                        </React.Fragment>
                    ))
                ) : (
                    <p className="data-message">No data available.</p> // Fallback if `attendanceData` is empty
                )}
            </div>


            {/* {hasFetched && attendanceData.length === 0 && (
                <div className="data-message">
                    No payslip data found for the selected criteria.
                </div>
            )} */}
        </>
    );
};

export default EmployeePayslip;